import { createBigQueryEvent } from '../base';
import { TECHNICAL_PARAMS } from './constants';

export const createTechnicalBigQueryEvent = (type) => createBigQueryEvent(type, TECHNICAL_PARAMS);
